import DocumentRepository from "../Repository/DocumentRepository";
import CreateDownload from "../UseCase/CreateDownload";
import ResourceRepository from "../Repository/ResourceRepository";
import DocumentResourceRepository from "../Repository/DocumentResourceRepository";
import DownloadManagerRepository from "../Repository/DownloadManagerRepository";
import getDatabase from "./database";

const createDownload: CreateDownload = new CreateDownload(
    new ResourceRepository(getDatabase()),
    new DocumentResourceRepository(getDatabase()),
    new DownloadManagerRepository(getDatabase()),
    new DocumentRepository(getDatabase()),
);

export default function getCreateDownload(): CreateDownload {
    return createDownload;
}